'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function AgendarRedirect() {
  const router = useRouter();

  useEffect(() => {
    router?.replace('/#agendar');
  }, [router]);

  return null;
}
